export enum environment {
	dev = "dev",
	QA = "QA",
	design = "design",
	production = "production",
}
